import { makeAutoObservable } from 'mobx';

import { CloudFunctionsService, FirebaseService } from '@services';
import { FeatureFlags } from '@types';
import { OfflineDefaultFeatureFlags, rollbar } from '@utils';

export default class FeatureFlagStore {
  featureFlags: FeatureFlags = {};
  cloudFunctionService = new CloudFunctionsService();
  firebaseService = new FirebaseService(this.cloudFunctionService);
  isLoading = true;

  constructor() {
    makeAutoObservable(this);
    this.retrieveFeatureFlags();
  }

  /** EC-1273 marketplace gate. */
  get isMarketplaceEnabled(): boolean {
    return this.featureFlags.enableMarketplace === true;
  }

  retrieveFeatureFlags = async () => {
    try {
      this.featureFlags =
        await this.firebaseService.getFirebaseRemoteConfig('feature_flags');
    } catch (error) {
      rollbar.error(
        'Feature flag store: Error retrieving feature flags',
        error as Error
      );
      return OfflineDefaultFeatureFlags;
    } finally {
      this.isLoading = false;
    }
  };
}
